import { COLOR_GREY_BORDER } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING_HALF } from "helpers/spacings";
import {
  CourtMarkings,
  ShotMarker,
  SVG_H,
  SVG_W,
  svgToGlX,
  svgToGlY,
  toSvgX,
  toSvgY,
} from "pages/games/BasketballCourt";
import React, { useRef } from "react";

// Inline court for placing/correcting a shot's on-court location.
// Reports x/y (0–100) back through onChange; persisting is the caller's job
// (the highlight form sends x/y in its own save mutation).
export default function ShotPlacementInput({ coordinates, made, onChange, maxHeight = 300 }) {
  const svgRef = useRef(null);

  const placeShot = (clientX, clientY) => {
    const rect = svgRef.current.getBoundingClientRect();
    const px = ((clientX - rect.left) / rect.width) * SVG_W;
    const py = ((clientY - rect.top) / rect.height) * SVG_H;
    onChange({ x: svgToGlX(py), y: svgToGlY(px) });
  };

  return (
    <div style={{ maxWidth: 360, width: "100%", flexShrink: 0 }}>
      {/* Inherits the surrounding text colour; opacity keeps it legible on the dark editor. */}
      <div
        style={{
          fontFamily: FONT_FAMILY_GRAPHIK,
          fontSize: 12,
          lineHeight: 1.4,
          opacity: 0.8,
          marginBottom: SPACING_HALF,
        }}
      >
        Select the location where the shot was taken.
      </div>
      <svg
        ref={svgRef}
        // intrinsic size + auto/max dims lets the browser scale the court down
        // to fit the available width OR height while preserving its aspect ratio.
        width={SVG_W}
        height={SVG_H}
        viewBox={`0 0 ${SVG_W} ${SVG_H}`}
        style={{
          maxWidth: "100%",
          maxHeight,
          width: "auto",
          height: "auto",
          display: "block",
          border: `1px solid ${COLOR_GREY_BORDER}`,
          cursor: "crosshair",
          touchAction: "none",
        }}
        onClick={(e) => placeShot(e.clientX, e.clientY)}
      >
        <CourtMarkings />
        {coordinates && <ShotMarker cx={toSvgX(coordinates.y)} cy={toSvgY(coordinates.x)} made={made} />}
      </svg>
    </div>
  );
}
